var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 16a1 1 0 0 1 1 1v4.586L28.586 13 20 4.414V9a1 1 0 0 1-1 1c-8.548 0-13.632 4.133-15.345 12.636C6.613 18.229 11.764 16 19 16M2.988 30.152C2.801 31.372 1 31.235 1 30 1 15.9 6.724 8.43 18 8.018v-4.81a1.5 1.5 0 0 1 2.56-1.062l9.794 9.793a1.5 1.5 0 0 1 0 2.122l-9.793 9.793A1.5 1.5 0 0 1 18 22.793v-4.778c-8.895.274-13.802 4.273-15.012 12.137"
})));
export default SvgShare;